var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZenitWorldDarkWhiteHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 37,
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 341.21 121.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #59faa8;\n      }\n\n      .cls-3 {\n        fill: #2b995c;\n      }\n\n      .cls-4 {\n        fill: #3fd380;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m233.54,91.1h4.16l5.38,18.01c.41,1.55.82,3.1,1.22,5.34.49-2.36.94-3.79,1.39-5.34l5.58-18.01h4.32l5.54,18.01c.49,1.59.9,3.14,1.34,5.34.49-2.49.9-3.99,1.3-5.3l5.42-18.06h4.08l-8.88,29.47h-3.83l-7.13-23.31-7.21,23.31h-3.91l-8.76-29.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m283.18,100.11c5.95,0,10.35,4.32,10.35,10.47s-4.4,10.47-10.35,10.47-10.39-4.32-10.39-10.47,4.4-10.47,10.39-10.47Zm0,17.52c3.83,0,6.52-2.89,6.52-7.05s-2.69-7.05-6.52-7.05-6.52,2.89-6.52,7.05,2.65,7.05,6.52,7.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m309.18,103.98h-1.71c-3.63,0-5.87,2.2-5.87,6.03v10.56h-3.83v-19.89h3.59l.24,3.02c.82-2.08,2.81-3.46,5.54-3.46.69,0,1.26.08,2.04.24v3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m312.84,120.57v-30h3.83v30h-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m320.99,110.67c0-6.11,3.55-10.6,9.46-10.6,3.06,0,5.62,1.35,6.97,3.79v-13.29h3.79v30h-3.42l-.33-3.63c-1.3,2.73-3.99,4.12-7.17,4.12-5.79,0-9.29-4.32-9.29-10.39Zm16.38-.12c0-4.08-2.41-7.01-6.32-7.01s-6.2,2.93-6.2,7.01,2.28,7.05,6.2,7.05,6.32-2.89,6.32-7.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m32.24,90.35s6.06,11.59,19.96,11.59,19.87-11.59,19.87-11.59l-19.87-37.68-19.96,37.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.19 0 0 90.35 32.24 90.35 68.21 27.89 52.19 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "68.21 27.89 104.46 90.35 72.06 90.35 52.2 55.69 68.21 27.89"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "127.61 22.52 172.15 22.52 172.15 32.43 142.29 68.77 143.15 70.12 172.15 70.12 172.15 80.89 126.51 80.89 126.51 71.22 156.24 34.39 155.48 33.12 127.54 33.12 127.61 22.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m200.9,71.8c-9.18,0-9.91-9.91-9.91-9.91h31.84c0-12.39-3.49-26.24-21.98-26.24s-21.98,15.6-21.98,22.02c0,6.97,2.29,24.59,21.75,24.59s21.56-15.42,21.56-15.42h-11.75s-.37,4.96-9.54,4.96Zm0-25.88c10,0,9.82,8.9,9.82,8.9h-19.64s1.38-8.9,9.82-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m232.93,37.11h10.19v10.74s1.74-12.2,15.88-12.2,15.14,14.32,15.14,19.18v25.97h-12.76v-25.23s.09-8.63-7.85-8.63-7.66,8.63-7.66,12.39v21.47h-12.94v-43.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "282.57 37.11 301.38 37.11 301.38 80.79 288.44 80.79 288.44 46.38 282.57 46.38 282.57 37.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 286.7,
    y: 19.68,
    width: 13.58,
    height: 12.85,
    rx: 5.55,
    ry: 5.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m340.47,46.38v-9.27h-12.76v-12.02h-11.56v12.02h-6.79v9.27h6.79v18.81s-1.65,16.06,16.88,16.06h7.43v-10.83h-7.07s-5.69.28-5.69-6.52v-17.53h12.76Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenitWorldDarkWhiteHorizontal);
export default __webpack_public_path__ + "static/media/Zenit World_Dark & White Horizontal.070ee15ccca585ba09b0b916173f203c.svg";
export { ForwardRef as ReactComponent };